export class PopUp extends React.Component<{ onClose: () => void, loading: boolean }, {}> {
    public render() {
        const { loading } = this.props;
        if (loading) {
            return (
                <div className="redMailPopUp">
                    <div className="loading"></div>
                    <p className="title">עוד רגע מסיימים...</p>
                </div>
            )
        } else {
            return (
                <div className="redMailPopUp">
                    <div className="finish"></div>
                    <p className="title">המידע התקבל ונשלח לבדיקה.</p>
                    <p className="subTitle">תודה על השיתוף</p>
                    <button className="popUpButton"><a href="/">חזרה לעמוד הבית</a></button>
                </div>
            )
        }
    }

}